export default __webpack_public_path__ + "static/floorceiling-e9af588f03a8f9b099ae119a17b05d00.jpg";